import React, {createContext} from 'react';

// Due to new version migration (16 -> 19) changed react.createContext to create context.
const CurrentPracticeContext = createContext();

export class CurrentPracticeProvider extends React.Component {
  state = {
    currentPractice: {},
  };

  componentDidMount() {
    const { value: currentPractice } = this.props;
    this.setCurrentPractice(currentPractice);
  }

  setCurrentPractice = newCurrentPractice => {
    this.setState({ currentPractice: newCurrentPractice });
  };

  render() {
    let { currentPractice } = this.state;
    const { children } = this.props;
    const sortAndGroupProviders = (updatedData) => {
      const priorityGroups = [
        ['Dr Pearl Lui, MD', 'Olivia Mannix, PA-C', 'Eric Nguyen, PA-C'],
        ['Dr John Meer, MD', 'Gaia Mistriel, PA', 'PA Zoe Rouder, PA-C'],
        [
          'Christine Pipchick, PA',
          'Suhasini Neelam Satish, PA',
          'Dr Maria Sequeira, MD',
        ],
        [
          'Dr. Lovonne Brown, MD',
          'Emma Poulshock, PA-C',
          'Dr Zinoviy Gutkovich, MD',
        ],
        ['James Lauren, NP', 'NP Karyl Soto, NP'],
        [
          'Dr. Jenny Gerner, MD',
          'Dr. Omar Hawasli, MD',
          'Dr Nadav Wallach, MD',
          'Shayna LaSala, NP',
          'Dr Ann Marie Gustafson, MD',
        ],
        ['Dr Marc Cimmino, DO', 'Dr. Wendy VanDyke, DO', 'Rachel Khaldar, PA'],
        [
          'Rebecca Wine, PA',
          'Nicole Kopchak, PA-C',
          'Shirina Braun, PA',
          'Dr Robert Schranze, MD',
          'NP Valerie Naggie, PMHNP-BC',
          'Dr Angelina Singh, DO',
        ],
      ];
  
      // Step 1: Sort everything by name
      const sorted = updatedData.sort((a, b) =>
        a.firstName.localeCompare(b.firstName)
      );
  
      // Step 3: map for quick lookup
      const providerMap = new Map(sorted.map((p) => [p.name, p]));
  
      // Step 4: extract priority providers in exact order
      const groupedPriority = [];
      const usedNames = new Set();
  
      priorityGroups.forEach((group) => {
        const groupItems = [];
  
        group.forEach((name) => {
          if (providerMap.has(name)) {
            groupItems.push(providerMap.get(name));
            usedNames.add(name);
          }
        });
  
        if (groupItems.length) {
          groupedPriority.push(...groupItems);
        }
      });
  
      // Step 5: remaining providers (not in priority list)
      const remaining = sorted.filter((p) => !usedNames.has(p.name));
  
      // Step 6: final result
      return [...remaining, ...groupedPriority];
    };

    let groupedProviders = sortAndGroupProviders(currentPractice.providers || []);
    currentPractice.providers = groupedProviders;

    return (
      <CurrentPracticeContext.Provider
        value={{
          id: currentPractice.id,
          currentPractice,
          setCurrentPractice: this.setCurrentPractice,
        }}
      >
        {children}
      </CurrentPracticeContext.Provider>
    );
  }
}

export const CurrentPracticeConsumer = CurrentPracticeContext.Consumer;

export default CurrentPracticeContext;
